import angular from 'angular';
import ravenJs from 'raven-js';
import ravenAngular from 'raven-js/plugins/angular';
import { hosts, version } from 'settings';

if (hosts.sentry) {
  const options = {
    release: version,
    ignoreErrors: [
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'fb_xd_fragment',
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      'conduitPage',
      'ntp is not defined',
    ],
    ignoreUrls: [
      /graph\.facebook\.com/i,
      /connect\.facebook\.net\/en_US\/all\.js/i,
      /extensions\//i,
      /^chrome:\/\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    ],
    whitelistUrls: [/https?:\/\/((dev|uat)-)?programs\.voome\.com\.au/],
    shouldSendCallback: function() {
      // only send 10% of errors
      return Math.random() * 100 <= 10;
    },
  };

  ravenJs
    .config(hosts.sentry, options)
    .addPlugin(ravenAngular, angular)
    .install();
}

export const raven = ravenJs;



// WEBPACK FOOTER //
// ./src/utils/raven.js